(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[53809],{

/***/ 65132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ TagsBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46376);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var TagsBlock = function(param) {
    var tags = param.tags;
    if (!tags) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tagsBlock),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().title),
                children: "Tags"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tagsList),
                children: tags.map(function(param) {
                    var title = param.title, slug = param.slug;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.blog.getRoute */ .y2.blog.getRoute(slug).path,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tag),
                        children: title
                    }, title);
                })
            })
        ]
    });
};
TagsBlock.defaultProps = {
    tags: []
};
TagsBlock.propTypes = {
    tags: prop_types__WEBPACK_IMPORTED_MODULE_3___default().instanceOf(Array)
};


/***/ }),

/***/ 12656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BlogCommon_Article; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./hocs/withScroll.js
var withScroll = __webpack_require__(12512);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./components/Common/FullScreenEstimation/index.jsx
var FullScreenEstimation = __webpack_require__(92261);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./utils/youtubeVideosContext.js
var youtubeVideosContext = __webpack_require__(76416);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./components/BlogCommon/Article/Author/styles.module.scss
var styles_module = __webpack_require__(70277);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/Article/Author/index.jsx




var Author = function(param) {
    var _author = param.author, avatarImage = _author.avatarImage, fullName = _author.fullName, position = _author.position, slug = _author.slug;
    return avatarImage && fullName && position && (slug ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper/* default */.Z, {
        path: "/person/".concat(slug),
        className: (styles_module_default()).author,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat(avatarImage, ")")
                },
                className: (styles_module_default()).avatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).authorInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: fullName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: position
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).author,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat(avatarImage, ")")
                },
                className: (styles_module_default()).avatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).authorInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: fullName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: position
                    })
                ]
            })
        ]
    }));
};
Author.defaultProps = {
    author: {
        avatarImage: "",
        fullName: "",
        position: ""
    }
};
Author.propTypes = {
    author: prop_types_default().shape({
        avatarImage: (prop_types_default()).string,
        fullName: (prop_types_default()).string,
        position: (prop_types_default()).string
    })
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__(31304);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./components/BlogCommon/Article/NavigationByTitles/styles.module.scss
var NavigationByTitles_styles_module = __webpack_require__(2686);
var NavigationByTitles_styles_module_default = /*#__PURE__*/__webpack_require__.n(NavigationByTitles_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/Article/NavigationByTitles/index.jsx
/* eslint-disable no-shadow */ 









var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var NavigationByTitles = function(param) {
    var articleBodyRef = param.articleBodyRef, articleSlug = param.articleSlug;
    var ref = (0,react.useState)([]), subtitles = ref[0], setSubtitles = ref[1];
    var ref1 = (0,react.useState)(false), isNavigationOpened = ref1[0], setIsNavigationOpened = ref1[1];
    var handleOnExpandClick = function() {
        return setIsNavigationOpened(!isNavigationOpened);
    };
    var handleOnItemClick = function(event) {
        var index = event.target.getAttribute("data-index");
        window.scrollBy({
            top: subtitles[index].element.getBoundingClientRect().top - constants/* HEADER_HEIGHT */.Mz,
            behavior: "smooth"
        });
        event.preventDefault();
    };
    (0,react.useEffect)(function() {
        if (articleBodyRef && articleBodyRef.current) {
            var subtitleRefs = articleBodyRef.current.getElementsByTagName("h2") || [];
            var subtitles = (0,_to_consumable_array/* default */.Z)(subtitleRefs).reduce(function(acc, subtitleRef) {
                var subtitle = subtitleRef.textContent;
                var slug = slugify_default()(subtitle);
                subtitleRef.setAttribute("id", slug);
                acc.push({
                    id: slug,
                    name: subtitle,
                    element: subtitleRef
                });
                return acc;
            }, []);
            setSubtitles(subtitles);
        }
        return function() {
            return setIsNavigationOpened(false);
        };
    }, [
        articleBodyRef,
        articleSlug
    ]);
    if (!subtitles.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (NavigationByTitles_styles_module_default()).navigation,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NavigationByTitles_styles_module_default()).navigationHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (NavigationByTitles_styles_module_default()).title,
                        children: "Contents"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (NavigationByTitles_styles_module_default()).expandButton,
                        onClick: handleOnExpandClick,
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (NavigationByTitles_styles_module_default()).buttonText,
                                children: isNavigationOpened ? "hide" : "expand"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((NavigationByTitles_styles_module_default()).arrow, (0,_define_property/* default */.Z)({}, (NavigationByTitles_styles_module_default()).reverseArrow, !isNavigationOpened)),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, {
                type: constants/* ANIMATED_TYPE.expandByHeight */.BK.expandByHeight,
                open: isNavigationOpened,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NavigationByTitles_styles_module_default()).navigationItems,
                    children: subtitles.map(function(subtitle, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            "data-index": index,
                            href: "#".concat(subtitle.id),
                            onClick: handleOnItemClick,
                            className: (NavigationByTitles_styles_module_default()).navigationLink,
                            children: "".concat(index + 1, ". ").concat(subtitle.name)
                        }, subtitle.id);
                    })
                })
            })
        ]
    });
};
NavigationByTitles.defaultProps = {
    articleBodyRef: null,
    articleSlug: ""
};
NavigationByTitles.propTypes = {
    articleBodyRef: prop_types_default().instanceOf(Object),
    articleSlug: (prop_types_default()).string
};

// EXTERNAL MODULE: ./components/BlogCommon/Article/styles.module.scss
var Article_styles_module = __webpack_require__(44932);
var Article_styles_module_default = /*#__PURE__*/__webpack_require__.n(Article_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/Article/index.jsx














var OldArticle = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 75287).then(__webpack_require__.bind(__webpack_require__, 75287));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75287)
            ];
        }
    }
});
var Article = function(param) {
    var introSection = param.introSection, slug = param.slug, title = param.title, oldBody = param.oldBody, body = param.body, introduction = param.introduction, headImage = param.headImage, maxScrollPosition = param.maxScrollPosition, author = param.author, publishedAt = param.publishedAt, youtubeVideosMetadata = param.youtubeVideosMetadata;
    var articleBodyRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isFullscreenEstimationOpen = ref[0], setFullscreenEstimationOpen = ref[1];
    (0,react.useEffect)(function() {
        return function() {
            if (slug) {
                ga/* default.trackEvent */.Z.trackEvent("Scroll", "".concat(maxScrollPosition.current, "%"), "/blog/".concat(slug), maxScrollPosition.current < 50);
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        };
    }, [
        slug
    ]);
    var context = (0,react.useMemo)(function() {
        return {
            isShown: isFullscreenEstimationOpen,
            open: function() {
                return setFullscreenEstimationOpen(true);
            }
        };
    }, [
        isFullscreenEstimationOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(youtubeVideosContext/* YoutubeVideosMetadataContext.Provider */.z.Provider, {
        value: youtubeVideosMetadata,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            ref: introSection,
            className: (Article_styles_module_default()).article,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    className: (Article_styles_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                            src: headImage.url,
                            alt: headImage.alt,
                            className: (Article_styles_module_default()).headImage,
                            priority: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Article_styles_module_default()).container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (Article_styles_module_default()).date,
                                    children: (0,helper/* formatDate */.p6)(publishedAt)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (Article_styles_module_default()).h1,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: introduction
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Author, {
                                    author: author
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Article_styles_module_default()).body,
                    ref: articleBodyRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationByTitles, {
                            articleBodyRef: articleBodyRef,
                            articleSlug: slug
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenEstimation.FullscreenEstimationContext.Provider, {
                            value: context,
                            children: oldBody ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OldArticle, {
                                oldBody: oldBody
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                document: body
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenEstimation["default"], {
                            isFullscreenEstimation: isFullscreenEstimationOpen,
                            closeFullscreenEstimation: function() {
                                return setFullscreenEstimationOpen(false);
                            }
                        })
                    ]
                })
            ]
        })
    });
};
Article.defaultProps = {
    oldBody: "",
    body: null,
    slug: "",
    title: "",
    introduction: "",
    publishedAt: "",
    youtubeVideosMetadata: {}
};
Article.propTypes = {
    introSection: prop_types_default().instanceOf(Object).isRequired,
    maxScrollPosition: prop_types_default().instanceOf(Object).isRequired,
    slug: (prop_types_default()).string,
    title: (prop_types_default()).string,
    oldBody: (prop_types_default()).string,
    body: prop_types_default().instanceOf(Object),
    introduction: (prop_types_default()).string,
    headImage: prop_types_default().instanceOf(Object).isRequired,
    author: prop_types_default().instanceOf(Object).isRequired,
    publishedAt: (prop_types_default()).string,
    youtubeVideosMetadata: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var BlogCommon_Article = ((0,withScroll/* default */.Z)(Article));


/***/ }),

/***/ 92261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FullscreenEstimationContext": function() { return /* binding */ FullscreenEstimationContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Common_ModalWindow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79897);
/* harmony import */ var UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59654);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18422);
/* harmony import */ var UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56362);
/* harmony import */ var utils_constants_contacts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32522);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66723);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);










var FeedbackForm = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(33714), __webpack_require__.e(84602), __webpack_require__.e(21148), __webpack_require__.e(43919), __webpack_require__.e(96419), __webpack_require__.e(49163), __webpack_require__.e(47569)]).then(__webpack_require__.bind(__webpack_require__, 49163));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49163)
            ];
        }
    },
    ssr: false
});
var FullScreenEstimation = function(param) {
    var isFullscreenEstimation = param.isFullscreenEstimation, closeFullscreenEstimation = param.closeFullscreenEstimation, extraDescription = param.extraDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Common_ModalWindow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isModalWindow: isFullscreenEstimation,
        closeModalWindow: closeFullscreenEstimation,
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().fullscreenEstimation),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().estimationContainer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    isBold: true,
                    children: "Got a project in mind?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                    children: [
                        "Fill in this form or",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            path: "mailto:".concat(utils_constants_contacts__WEBPACK_IMPORTED_MODULE_8__/* .EMAIL_LINK */ .Vr),
                            children: "send us an e-mail"
                        })
                    ]
                }),
                isFullscreenEstimation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeedbackForm, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().feedbackForm),
                    isBudgetSlider: true,
                    formKey: "estimation",
                    extraDescription: extraDescription,
                    withoutAdditionalInfo: true
                })
            ]
        })
    });
};
FullScreenEstimation.propTypes = {
    isFullscreenEstimation: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool.isRequired),
    closeFullscreenEstimation: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().func.isRequired),
    extraDescription: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string)
};
var FullscreenEstimationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isShown: false,
    open: function() {
        return null;
    }
});
/* harmony default export */ __webpack_exports__["default"] = (FullScreenEstimation);


/***/ }),

/***/ 76259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getArticleProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6572);



function getAuthorProps() {
    var author = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).author;
    var authorFields = (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getDocumentFields */ .OA)(author, [
        "fullName",
        "position",
        "avatar",
        "slug", 
    ]);
    var avatarImage = (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getFileUrl */ .qm)(authorFields.avatar);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, authorFields), {
        avatarImage: avatarImage
    });
}
function getFAQList(param) {
    var frequentlyAskedQuestions = param.frequentlyAskedQuestions;
    if (!frequentlyAskedQuestions) {
        return [];
    }
    return frequentlyAskedQuestions.map(function(question) {
        return (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getDocumentFields */ .OA)(question, [
            "question",
            "answer"
        ]);
    });
}
function getTagsList(param) {
    var tagsList = param.tagsList;
    if (!tagsList) {
        return [];
    }
    return tagsList.map(function(question) {
        return (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getDocumentFields */ .OA)(question, [
            "title",
            "slug"
        ]);
    });
}
function getArticleProps() {
    var article = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).article;
    var articleFields = (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getDocumentFields */ .OA)(article, [
        "slug",
        "title",
        "description",
        "oldBody",
        "body",
        "introduction",
        "headImageUrl",
        "publishedAt",
        "updatedAt",
        "tagsList",
        "categoryTag",
        "metaTitle",
        "metaDescription",
        "author",
        "frequentlyAskedQuestions", 
    ]);
    var headImage = (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getImage */ .gJ)(articleFields.headImageUrl);
    var author = getAuthorProps({
        author: articleFields.author
    });
    var faqList = getFAQList(articleFields);
    var tagsList = getTagsList(articleFields);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, articleFields), {
        headImage: headImage,
        author: author,
        faqList: faqList,
        tagsList: tagsList
    });
}


/***/ }),

/***/ 12512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23493);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_2__);




var withScroll = function(Component) {
    return function(props) {
        var maxScrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
        var lastScrollTop = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
        var setMaxScrollPosition = function(value) {
            maxScrollPosition.current = value;
        };
        var setLastScrollTop = function(value) {
            lastScrollTop.current = value;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var saveScrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default()(function(scroll) {
            return setMaxScrollPosition(scroll);
        }, 500), []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var saveLastScrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default()(function(scroll) {
            return setLastScrollTop(scroll);
        }, 500), []);
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            var getScrollPercent = function() {
                var documentElement = document.documentElement, body = document.body;
                var scrollTop = documentElement.scrollTop || body.scrollTop;
                var scrollHeight = documentElement.scrollHeight || body.scrollHeight;
                var scrollPercent = (scrollTop / (scrollHeight - documentElement.clientHeight) * 100).toFixed(2);
                switch(true){
                    case scrollPercent >= 0 && scrollPercent < 25:
                        return 25;
                    case scrollPercent >= 25 && scrollPercent < 50:
                        return 50;
                    case scrollPercent >= 50 && scrollPercent < 75:
                        return 75;
                    case scrollPercent >= 75 && scrollPercent <= 100:
                        return 100;
                    default:
                        return 25;
                }
            };
            var setMaxScroll = function() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                if (scrollTop > maxScrollPosition.current) {
                    var scrollPercent = getScrollPercent();
                    if (scrollPercent > maxScrollPosition.current) {
                        saveScrollPosition(scrollPercent);
                    }
                }
                saveLastScrollPosition(scrollTop <= 0 ? 0 : scrollTop);
            };
            window.addEventListener("scroll", setMaxScroll);
            return function() {
                window.removeEventListener("scroll", setMaxScroll);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            maxScrollPosition: maxScrollPosition,
            lastScrollTop: lastScrollTop
        }, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withScroll);


/***/ }),

/***/ 76416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useYoutubeVideoMetadata; },
/* harmony export */   "z": function() { return /* binding */ YoutubeVideosMetadataContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var YoutubeVideosMetadataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var useYoutubeVideoMetadata = function(videoId) {
    var videosMetadata = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(YoutubeVideosMetadataContext);
    return videosMetadata[videoId];
};


/***/ }),

/***/ 70277:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"author":"styles_author__a2_uT","avatar":"styles_avatar__dA1c5","authorInfo":"styles_authorInfo___carz"};

/***/ }),

/***/ 2686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__zivU1","navigationHeader":"styles_navigationHeader__4odHK","title":"styles_title__DTas4","expandButton":"styles_expandButton__JmLeP","buttonText":"styles_buttonText__ylGUI","arrow":"styles_arrow__lNrmY","reverseArrow":"styles_reverseArrow__r7jbd","navigationItems":"styles_navigationItems__AefcT","navigationLink":"styles_navigationLink__F5aVn"};

/***/ }),

/***/ 46376:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tagsBlock":"styles_tagsBlock__lvVbj","title":"styles_title__BehH_","tagsList":"styles_tagsList__TBgCk","tag":"styles_tag__9QMpJ"};

/***/ }),

/***/ 44932:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__Ixp2v","h3":"styles_h3__CooIR","paragraph":"styles_paragraph___jee6","body":"styles_body__90l3W","a":"styles_a__vtHH4","ul":"styles_ul__6w0UV","ol":"styles_ol__aNt50","quote":"styles_quote__EItiR","h1":"styles_h1__bBevL","headImage":"styles_headImage__bWWem","article":"styles_article__2Ifrk","header":"styles_header__BxSYV","container":"styles_container___xSqx","date":"styles_date__gWcLD"};

/***/ }),

/***/ 66723:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullscreenEstimation":"styles_fullscreenEstimation__Rg_DE","estimationContainer":"styles_estimationContainer__gixM_","feedbackForm":"styles_feedbackForm__cR1Pq","title":"styles_title__07SXR","subtitle":"styles_subtitle__fjFtJ"};

/***/ })

}]);